<div class="container-fluid px-0 py-3">
    <div>
        <div class="text-center">
            <div class="titre">{{'DetailProduct.accessories'|translate|uppercase}}</div>
        </div>
        <app-carousel [elements]="products" [display]="enum" [champs]="champs" [isLink]="true"></app-carousel>
    </div>
</div>